document
  .querySelector('.individual_button')
  .addEventListener('click', function () {
    document.querySelector('.field_group_corporate').classList.add('hidden');
    document.querySelector('.field_group_margin_bottom').classList.remove('mb');

    document.querySelector('.field_group_individual').classList.remove('hidden');
    document
      .querySelectorAll('.field_group_individual input')
      .forEach(el => el.removeAttribute('disabled'));

    document
      .querySelector('.company_name_required')
      .removeAttribute('required', '');
    document
      .querySelector('.previously_traded_required')
      .removeAttribute('required', '');
    document
      .querySelector('.company_name_required')
      .setAttribute('disabled', '');
    document
      .querySelector('.previously_traded_required')
      .setAttribute('disabled', '');
  });
document
  .querySelector('.corporate_button')
  .addEventListener('click', function () {
    document.querySelector('.field_group_corporate').classList.remove('hidden');
    document.querySelector('.field_group_margin_bottom').classList.add('mb');

    document.querySelector('.field_group_individual').classList.add('hidden');
    document
      .querySelectorAll('.field_group_individual input')
      .forEach(el => {
        el.checked = false;
        el.setAttribute('disabled', '');
      });

    document
      .querySelector('.company_name_required')
      .setAttribute('required', '');
    document
      .querySelector('.previously_traded_required')
      .setAttribute('required', '');
    document
      .querySelector('.company_name_required')
      .removeAttribute('disabled', '');
    document
      .querySelector('.previously_traded_required')
      .removeAttribute('disabled', '');
  });
